module.exports = __webpack_public_path__ + "img/yellow.645873b5.svg";